import "./styles.css";
import { BCMSDate } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
export default function PickerHeader(props) {
    let { month1, month2, setViewDate, leftDisabled,rightDisabled } = props;
const setToday = ()=>(
   setViewDate(BCMSDate.init()) 
)
    return (
        <div className="picker-header">
            <div className="flex-container flex-horizontal align-center">
                <div className="left-container set-width">
                    <MonthLeft setViewDate={setViewDate} viewDate={month1} disabled={leftDisabled} />
                </div>
                <div className="date-select-month flex-width text-center">
                    <span className="left-calendar-label">
                        <b>
                            <span className='month'>{month1.getLongMonth} </span> 
                            <span className='year'>{month1.yearInt}</span> 
                        </b>
                    </span>
                </div>  
                <div className="right-container set-width">
                    <MonthRight setViewDate={setViewDate} viewDate={month1} disabled={rightDisabled}/>
                </div>
            </div>  
        </div>
    )
}

export function MonthLeft(props) {
    let {disabled, setViewDate, viewDate} = props;
    
    let onClick = function () {
        if (disabled(viewDate) !== false) {
            setViewDate(viewDate.offset([0, -1, 0]))
        }
    }
    return (
        <button className={`left-button ${disabled(viewDate) === false ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="LeftChevronIcon" /> </button>
    )
}

export function MonthRight(props) {
    let {disabled, setViewDate, viewDate} = props;
  
    let onClick = function () {
        if (disabled(viewDate) !== false) {
           setViewDate(viewDate.setToFirst().offsetMonth( 1))
        }
    }
    return (
        <button className={`right-button ${disabled(viewDate) === false ? "disabled-month-chevron":""}`} onClick={onClick}> <SVGAsset id="RightChevronIcon" /> </button>
    )
}



